/*
* son las entidades cuyo tipo es prospecto
*/
import { Component, ViewChild } from '@angular/core';
import { VerCaracteristicasComponent } from '../../../../forms/productos/caracteristicas/ver-caracteristicas/ver-caracteristicas.component';

@Component({
  selector: 'app-caracteristicas',
  templateUrl: './caracteristicas.component.html',
  styleUrls: ['./caracteristicas.component.scss']
})
export class CaracteristicasComponent {
  @ViewChild('verCaracteristicas') verCaracteristicas: VerCaracteristicasComponent;

  constructor() { }

  actualizarTabla(): void {
    this.verCaracteristicas.actualizarTabla();
  }
}

